import { useMemo } from 'react';
import { DimensionSettings } from '@fullstory/proto/fs/api/metrics';
import { dimensionsFromDimensionSettings, dimensionsToDimensionState } from '../utils';

export function useDimensionStateFromSettings(
  dimensionSettings: DimensionSettings | null | undefined,
) {
  return useMemo(
    () =>
      dimensionsToDimensionState(dimensionsFromDimensionSettings(dimensionSettings), {
        noFallback: !!dimensionSettings?.noFallback,
      }),
    [dimensionSettings],
  );
}
